/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactElement, useState, useEffect, ChangeEvent } from 'react'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import ChipInput from 'material-ui-chip-input'
import * as yup from 'yup'
import _ from 'lodash'
import { Form, Alert } from 'react-bootstrap'
import API from '@aws-amplify/api'
import { Formik, FieldArray } from 'formik'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { observer, inject } from 'mobx-react'
import { FormControl, ListItemText, Divider, TextField, ListItem } from '@material-ui/core'
import { MultiSelect } from 'react-multi-select-component'
import { City } from 'country-state-city'
import { ToastTypeEnum } from '../../components/Dashboard/Toasts'
import LoadingButton from '../../components/LoadingButton'
import { Settings as SettingsStore } from '../../stores/settings'
import Spinner from '../../components/Spinner'
import MavCircleCheckBox from '../../components/common/MavCircleCheckBox'
import {
  headCountPrefill,
  industriesPrefill,
  locationPrefill,
  revenuesPrefill,
  seniorityLevelPrefill,
} from '../../utils/constants'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: '100%',
    },
    tabs: {
      '& .MuiTab-root': {
        flex: 1,
        minWidth: 'unset',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: '#27a9e0',
      },
      '& .MuiTab-textColorPrimary.Mui-selected': {
        color: '#27a9e0',
      },
    },
    formControl: {
      margin: theme.spacing(1),
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
      maxHeight: '620px',
      '@media (max-width: 540px)': {
        margin: 0,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
      },
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  }),
)
const industryOptions = industriesPrefill?.map(industry => ({ label: industry, value: industry }))
interface Props extends RouteComponentProps {
  // eslint-disable-next-line react/require-default-props
  settings?: SettingsStore
}

const schema = yup.object({
  userCriteria: yup.array().of(
    yup.object({
      activated: yup.boolean(),
      companies: yup.array().when('companySearch', {
        is: true,
        then: yup.array().required('Companies are required for Company search'),
      }),
      companySearch: yup.boolean(),
      dncCompanies: yup.array().of(yup.string()),
      enabled: yup.boolean(),
      headCount: yup.array().when('enabled', {
        is: true,
        then: yup.array().required('Headcount is a required field'),
      }),
      industries: yup.array().when('enabled', {
        is: true,
        then: yup
          .array()
          .of(yup.string())
          .required('Industries is a required field'),
      }),
      cities: yup.array().when('enabled', {
        is: true,
        then: yup
          .array()
          .of(yup.string())
          .required('Cities is a required field'),
      }),
      locations: yup.array().when('enabled', {
        is: true,
        then: yup.array().required('US STATES is a required field'),
      }),
      revenues: yup.array().when('enabled', {
        is: true,
        then: yup.array().when('companySearch', {
          is: false,
          then: yup
            .array()
            .of(yup.string())
            .required('Revenue is a required field'),
        }),
      }),
      missionName: yup.string(),
      seniorityLevels: yup.array().when('enabled', {
        is: true,
        then: yup.array().required('Seniority Levels is a required field'),
      }),
      titles: yup.array().of(yup.string()),
      titleExclusions: yup.array().of(yup.string()),
    }),
  ),
})
const AdminCriteria: FC<Props> = ({ settings }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [currentRecon, setCurrentRecon] = useState(0)
  const [headCounts, setHeadCounts] = useState(['All'])
  const [seniorityLevel, setSeniorityLevels] = useState(['All'])
  const [location, setLocations] = useState(['All US States'])
  const [city, setCities] = useState(['All US Cities'])
  const [revenue, setRevenues] = useState(['All'])
  const [stateFilter, setStateFilter] = useState('')
  const [cityFilter, setCityFilter] = useState('')
  const classes = useStyles()
  const history = useHistory()

  const userCriteria = settings?.criteria?.map(criteria => ({
    ...criteria,
  }))
  const setInitialDatas = (id: number): void => {
    if (userCriteria && userCriteria?.length !== 0) {
      const values = userCriteria
      setHeadCounts(values[id].headCount)
      setSeniorityLevels(values[id].seniorityLevels)
      setLocations(values[id].locations)
      setCities(values[id].cities)
      setRevenues(values[id].revenues)
    }
  }

  const handleClear = (setFieldValue: (string, any) => void, recon): void => {
    setFieldValue(`${recon}.headCount`, ['All'])
    setFieldValue(`${recon}.seniorityLevels`, ['All'])
    setFieldValue(`${recon}.locations`, ['any'])
    setFieldValue(`${recon}.cities`, ['any'])
    setFieldValue(`${recon}.revenues`, ['All'])
    setFieldValue(`${recon}.industries`, ['all'])
    setFieldValue(`${recon}.titles`, [])
    setFieldValue(`${recon}.titleExclusions`, [])
    setFieldValue(`${recon}.dncCompanies`, [])

    // Previous states also needs to be cleared as we are using these while updaing values
    setHeadCounts(['All'])
    setSeniorityLevels(['All'])
    setLocations(['All US States'])
    setCities(['All US Cities'])
    setRevenues(['All'])
  }

  const handleReconChange = (id: number): void => {
    setCurrentRecon(id)
  }

  const handleStateFilterChange = (e: any): void => {
    setStateFilter(e.target.value)
  }

  const handleCityFilterChange = (e: any): void => {
    setCityFilter(e.target.value)
  }

  const getCitiesOfStates = (
    value,
  ): {
    stateCode: string
    label: string
    value: string
  }[] => {
    const countryCode = 'US'
    // todo - clean up list? (duplicates/'county'/'borough', order, etc)
    interface Cities {
      name: string
      stateCode: string
    }
    let allSelectedCities: Cities[] = []
    for (let i = 0; i < value.length; i += 1) {
      if (value[i] !== 'any') {
        if (allSelectedCities[0]) {
          allSelectedCities = allSelectedCities.concat(City.getCitiesOfState(countryCode, value[i]))
        } else {
          allSelectedCities = City.getCitiesOfState(countryCode, value[i])
        }
      }
    }
    let mappedCities = allSelectedCities.map(tCity => ({
      label: tCity.name,
      value: tCity.name,
      stateCode: tCity.stateCode,
    }))
    mappedCities = mappedCities.filter(
      (localVal, index, self) => index === self.findIndex(t => t.label === localVal.label),
    )
    return mappedCities
  }

  const handleChangeValue = (
    name: string,
    setFieldValue: (string, any) => void,
    fieldName: string,
    type: string,
  ): void => {
    let value: string[] = []
    if (type === 'headCount') {
      value = [...headCounts]
    } else if (type === 'seniorityLevels') {
      value = [...seniorityLevel]
    } else if (type === 'locations') {
      value = [...location]
    } else if (type === 'cities') {
      value = [...city]
    } else if (type === 'revenues') {
      value = [...revenue]
    }
    if (name === 'All') {
      if (value.includes('All')) {
        value = []
      } else {
        value = ['All']
      }
    } else if (name === 'All US States') {
      if (value.includes('any')) {
        value = []
      } else {
        value = ['any']
      }
    } else if (name === 'All US Cities') {
      if (value.includes('any') || value.includes('Any')) {
        value = []
      } else {
        value = ['any']
      }
    } else {
      if (value.includes('All')) {
        value = value.filter(item => item !== 'All')
      }
      if (value.includes('any')) {
        value = value.filter(item => item !== 'any')
      }
      if (value.includes(name)) {
        value = value.filter(item => item !== name)
      } else {
        value.push(name)
      }
    }
    setFieldValue(fieldName, value)
    if (type === 'locations' && name === 'All US States') {
      let cities = ['any']
      if (!value.includes('any')) {
        cities = []
      }
      const citiesField = fieldName.replace('locations', 'cities')
      setFieldValue(citiesField, cities)
    }
    if (type === 'headCount') {
      setHeadCounts(value)
    } else if (type === 'seniorityLevels') {
      setSeniorityLevels(value)
    } else if (type === 'locations') {
      setLocations(value)
    } else if (type === 'cities') {
      setCities(value)
    } else if (type === 'revenues') {
      setRevenues(value)
    }
  }

  const updateCriteria = async (values): Promise<void> => {
    const localValues = values
    localValues.userCriteria.forEach((value, i) => {
      if (value.companySearch) {
        localValues.userCriteria[i].industries = ['all']
        localValues.userCriteria[i].dncCompanies = []
      } else {
        localValues.userCriteria[i].companies = []
      }
      if (localValues.userCriteria[i].locations[0] === 'All US States') {
        localValues.userCriteria[i].locations[0] = 'any'
      }
      if (localValues.userCriteria[i].cities[0] === 'All US Cities') {
        localValues.userCriteria[i].cities[0] = 'any'
      }
      if (localValues.userCriteria[i].titles.length === 0) {
        localValues.userCriteria[i].titles = ['all']
      }
    })
    setIsLoading(true)

    let myInit = {}
    console.log(',,,,,,', localValues.userCriteria)
    myInit = {
      body: { criteria: localValues.userCriteria },
    }

    try {
      await API.post('mav-outlook-api', '/V2/users/prospectCriteria', myInit)

      settings?.pushToToasts({
        type: ToastTypeEnum.INFO,
        message:
          "Your changes are being processed. It will take some time before they're available on this page.",
      })
      settings?.getCriteria()
      setIsLoading(false)
    } catch (e) {
      console.error(e)

      setIsLoading(false)
    }
  }

  const handleEnagePage = (): void => {
    history.push('/do-not-engage')
  }

  useEffect(() => {
    settings?.getCriteria()
  }, [])

  useEffect(() => {
    if (settings?.criteria?.length) {
      setInitialDatas(0)
    }
  }, [settings?.criteria])

  useEffect(() => {
    setInitialDatas(currentRecon)
  }, [currentRecon])

  if (settings?.isLoading || !settings?.criteria?.length) {
    return <Spinner />
  }

  const RenderClearTagsButton = ({ handleClearTags }): any => (
    <>
      <span
        style={{
          fontSize: 14,
          color: 'grey',
          userSelect: 'none',
        }}
        className="cursor-pointer"
        onClick={(): void => {
          handleClearTags()
        }}
      >
        Clear
      </span>
    </>
  )

  return (
    <div className="criteria">
      <div className="w-100">
        <Formik
          validationSchema={schema}
          onSubmit={updateCriteria}
          initialValues={{
            userCriteria,
          }}
          enableReinitialize
        >
          {({
            handleSubmit,
            values,
            touched,
            errors,
            submitCount,
            setFieldValue,
          }): ReactElement => {
            return (
              <Form noValidate onSubmit={handleSubmit}>
                <FieldArray name="criteria">
                  {(): ReactElement => {
                    return (
                      <div className={classes.root}>
                        <Divider />
                        <div className="section white-box">
                          {settings?.criteria?.map((_criteria, i) => (
                            <ListItem
                              button
                              className={`mav-modal-title ${currentRecon === i ? 'active' : ''}`}
                              key={`Recon ${i + 1}`}
                              onClick={(): void => handleReconChange(i)}
                            >
                              <ListItemText primary={`RECON #${i + 1}`} />
                            </ListItem>
                          ))}
                        </div>
                        <Divider />
                        {settings?.criteria?.map((_criteria, i) => {
                          const cityOptions = getCitiesOfStates(
                            _.get(values, `userCriteria.${i}.locations`),
                          )
                          const industries = {
                            value: _.get(values, `userCriteria.${i}.industries`) || [],
                            touched: _.get(touched, `userCriteria.${i}.industries`),
                            errors: _.get(errors, `userCriteria.${i}.industries`),
                          }
                          const titles = {
                            value: _.get(values, `userCriteria.${i}.titles`),
                            touched: _.get(touched, `userCriteria.${i}.titles`),
                            errors: _.get(errors, `userCriteria.${i}.titles`),
                          }
                          const titleExclusions = {
                            value: _.get(values, `userCriteria.${i}.titleExclusions`),
                            touched: _.get(touched, `userCriteria.${i}.titleExclusions`),
                            errors: _.get(errors, `userCriteria.${i}.titleExclusions`),
                          }
                          const dncCompanies = {
                            value: _.get(values, `userCriteria.${i}.dncCompanies`),
                            touched: _.get(touched, `userCriteria.${i}.dncCompanies`),
                            errors: _.get(errors, `userCriteria.${i}.dncCompanies`),
                          }
                          const headCount = {
                            value: _.get(values, `userCriteria.${i}.headCount`),
                            touched: _.get(touched, `userCriteria.${i}.headCount`),
                            errors: _.get(errors, `userCriteria.${i}.headCount`),
                          }
                          const seniorityLevels = {
                            value: _.get(values, `userCriteria.${i}.seniorityLevels`),
                            touched: _.get(touched, `userCriteria.${i}.seniorityLevels`),
                            errors: _.get(errors, `userCriteria.${i}.seniorityLevels`),
                          }
                          const locations = {
                            value: _.get(values, `userCriteria.${i}.locations`),
                            touched: _.get(touched, `userCriteria.${i}.locations`),
                            errors: _.get(errors, `userCriteria.${i}.locations`),
                          }
                          const revenues = {
                            value: _.get(values, `userCriteria.${i}.revenues`),
                            touched: _.get(touched, `userCriteria.${i}.revenues`),
                            errors: _.get(errors, `userCriteria.${i}.revenues`),
                          }
                          const companies = {
                            value: _.get(values, `userCriteria.${i}.companies`),
                            touched: _.get(touched, `userCriteria.${i}.companies`),
                            errors: _.get(errors, `userCriteria.${i}.companies`),
                          }
                          const enabled = {
                            value: _.get(values, `userCriteria.${i}.enabled`),
                            touched: _.get(touched, `userCriteria.${i}.enabled`),
                            errors: _.get(errors, `userCriteria.${i}.enabled`),
                          }
                          const activated = {
                            value: _.get(values, `userCriteria.${i}.activated`),
                            touched: _.get(touched, `userCriteria.${i}.activated`),
                            errors: _.get(errors, `userCriteria.${i}.activated`),
                          }
                          const missionName = {
                            value: _.get(values, `userCriteria.${i}.missionName`),
                            touched: _.get(touched, `userCriteria.${i}.missionName`),
                            errors: _.get(errors, `userCriteria.${i}.missionName`),
                          }
                          const cities = {
                            value: _.get(values, `userCriteria.${i}.cities`),
                            touched: _.get(touched, `userCriteria.${i}.cities`),
                            errors: _.get(errors, `userCriteria.${i}.cities`),
                          }
                          if (!missionName.value) {
                            setFieldValue(
                              `userCriteria.${i}.missionName`,
                              userCriteria &&
                                userCriteria[i] &&
                                userCriteria[i].missions &&
                                userCriteria[i].missions.firstTouch
                                ? userCriteria[i].missions.firstTouch[0]
                                : 'Mission 1',
                            )
                          }
                          const companySearch = {
                            value: _.get(values, `userCriteria.${i}.companySearch`),
                            touched: _.get(touched, `userCriteria.${i}.companySearch`),
                            errors: _.get(errors, `userCriteria.${i}.companySearch`),
                          }
                          return (
                            <div
                              key={`Recon section ${i + 1}`}
                              style={{
                                maxWidth: '100%',
                                width: '100%',
                                display: currentRecon === i ? 'block' : 'none',
                              }}
                            >
                              <div className="section white-box">
                                <Form.Group controlId="companySearch" className="companySearch">
                                  <MavCircleCheckBox
                                    title="COMPANY RECON"
                                    status={companySearch.value}
                                    handleClick={(): void => {
                                      setFieldValue(
                                        `userCriteria.${i}.companySearch`,
                                        !companySearch.value,
                                      )
                                    }}
                                  />
                                </Form.Group>
                                <Form.Group controlId="enabled" className="enabled">
                                  <MavCircleCheckBox
                                    title="ENABLE SEARCH"
                                    status={enabled.value}
                                    disableType="times"
                                    isInvalid={submitCount > 0 && !!enabled.errors}
                                    handleClick={(): void => {
                                      setFieldValue(`userCriteria.${i}.enabled`, !enabled.value)
                                      if (!enabled.value) {
                                        setFieldValue(`userCriteria.${i}.activated`, false)
                                      }
                                    }}
                                  />
                                </Form.Group>
                                <Form.Group
                                  controlId="activated"
                                  className="activated"
                                  style={{ display: enabled.value ? 'block' : 'none' }}
                                >
                                  <MavCircleCheckBox
                                    title="AUTO SCHEDULE MATCHED CONTACTS"
                                    status={activated.value}
                                    isInvalid={submitCount > 0 && !!activated.errors}
                                    handleClick={(): void => {
                                      setFieldValue(`userCriteria.${i}.activated`, !activated.value)
                                    }}
                                  />
                                </Form.Group>
                              </div>
                              <Divider />
                              <div
                                className={`section selectors ${
                                  companySearch.value ? 'company' : ''
                                }`}
                              >
                                <FormControl className={classes.formControl}>
                                  <ListItemText primary="HEAD COUNTS" className="sub-title" />
                                  <Divider />
                                  {headCount.errors && headCount.touched ? (
                                    <Alert variant="danger">{headCount.errors}</Alert>
                                  ) : null}
                                  {headCountPrefill?.map(name => (
                                    <div key={`headCount-${name}`}>
                                      <MavCircleCheckBox
                                        title={name}
                                        status={headCount.value?.includes(name)}
                                        handleClick={(): void => {
                                          handleChangeValue(
                                            name,
                                            setFieldValue,
                                            `userCriteria.${i}.headCount`,
                                            'headCount',
                                          )
                                        }}
                                      />
                                      <Divider />
                                    </div>
                                  ))}
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                  <ListItemText primary="SENIORITY LEVELS" className="sub-title" />
                                  <Divider />
                                  {seniorityLevels.errors && seniorityLevels.touched ? (
                                    <Alert variant="danger">{seniorityLevels.errors}</Alert>
                                  ) : null}
                                  {seniorityLevelPrefill?.map(name => (
                                    <div key={`level-${name}`}>
                                      <MavCircleCheckBox
                                        title={name}
                                        status={seniorityLevels.value?.includes(name)}
                                        handleClick={(): void => {
                                          handleChangeValue(
                                            name,
                                            setFieldValue,
                                            `userCriteria.${i}.seniorityLevels`,
                                            'seniorityLevels',
                                          )
                                        }}
                                      />
                                      <Divider />
                                    </div>
                                  ))}
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                  <ListItemText primary="US STATES" className="sub-title" />
                                  {locations.errors && locations.touched ? (
                                    <Alert variant="danger">{locations.errors}</Alert>
                                  ) : null}
                                  <TextField
                                    id="outlined-states"
                                    label="Search US States"
                                    variant="outlined"
                                    size="small"
                                    value={stateFilter}
                                    onChange={handleStateFilterChange}
                                  />
                                  {locationPrefill
                                    ?.filter(item =>
                                      item.toLowerCase().includes(stateFilter.toLowerCase()),
                                    )
                                    .map(name => {
                                      const tempValue = name === 'All US States' ? 'any' : name
                                      return (
                                        <div key={`location-${name}`}>
                                          <MavCircleCheckBox
                                            title={name}
                                            status={locations.value?.includes(tempValue)}
                                            handleClick={(): void => {
                                              handleChangeValue(
                                                name,
                                                setFieldValue,
                                                `userCriteria.${i}.locations`,
                                                'locations',
                                              )
                                            }}
                                          />
                                          <Divider />
                                        </div>
                                      )
                                    })}
                                </FormControl>
                                {_.get(values, `userCriteria.${i}.locations`).length > 0 &&
                                  _.get(values, `userCriteria.${i}.locations`).length <= 3 && (
                                    <FormControl
                                      className={`${classes.formControl} ${
                                        location.length === 0 ? 'disable' : ''
                                      }`}
                                      style={
                                        locations.value[0]?.toLowerCase() !== 'any' &&
                                        locations.value.length !== 0
                                          ? {}
                                          : { display: 'none' }
                                      }
                                    >
                                      <ListItemText primary="US CITIES" className="sub-title" />
                                      {cities.errors && cities.touched ? (
                                        <Alert variant="danger">{cities.errors}</Alert>
                                      ) : null}
                                      <TextField
                                        id="outlined-cities"
                                        label="Search US Cities"
                                        variant="outlined"
                                        size="small"
                                        value={cityFilter}
                                        onChange={handleCityFilterChange}
                                      />
                                      <MavCircleCheckBox
                                        title="All US Cities"
                                        status={cities.value?.includes('any')}
                                        handleClick={(): void => {
                                          handleChangeValue(
                                            'All US Cities',
                                            setFieldValue,
                                            `userCriteria.${i}.cities`,
                                            'cities',
                                          )
                                        }}
                                      />
                                      <Divider />
                                      {cityOptions
                                        ?.filter(item =>
                                          item.value
                                            .toLowerCase()
                                            .includes(cityFilter.toLowerCase()),
                                        )
                                        .map(name => {
                                          const tempValue = name.value
                                          return (
                                            <div key={`city-${name.value}`}>
                                              <MavCircleCheckBox
                                                title={`${name.label} (${name.stateCode})`}
                                                status={cities.value?.includes(tempValue)}
                                                handleClick={(): void => {
                                                  handleChangeValue(
                                                    name.value,
                                                    setFieldValue,
                                                    `userCriteria.${i}.cities`,
                                                    'cities',
                                                  )
                                                }}
                                              />
                                              <Divider />
                                            </div>
                                          )
                                        })}
                                    </FormControl>
                                    // eslint-disable-next-line @typescript-eslint/indent
                                  )}
                                <FormControl
                                  className={classes.formControl}
                                  style={!companySearch.value ? {} : { display: 'none' }}
                                >
                                  <ListItemText primary="REVENUE" className="sub-title" />
                                  <Divider />
                                  {revenues.errors && revenues.touched ? (
                                    <Alert variant="danger">{revenues.errors}</Alert>
                                  ) : null}
                                  {revenuesPrefill?.map(name => (
                                    <div key={`revenue-${name}`}>
                                      <MavCircleCheckBox
                                        title={name}
                                        status={revenues.value?.includes(name)}
                                        handleClick={(): void => {
                                          handleChangeValue(
                                            name,
                                            setFieldValue,
                                            `userCriteria.${i}.revenues`,
                                            'revenues',
                                          )
                                        }}
                                      />
                                      <Divider />
                                    </div>
                                  ))}
                                </FormControl>
                                <Form.Group
                                  controlId={`userCriteria-${i}-companies`}
                                  className="criteria-input"
                                  style={
                                    companySearch.value ? { display: 'block' } : { display: 'none' }
                                  }
                                >
                                  <ListItemText
                                    primary="COMPANY NAMES"
                                    className="sub-title align"
                                  />
                                  <ChipInput
                                    disabled={!companySearch.value}
                                    id="companies"
                                    label=""
                                    helperText="Example: Maverick, Google, Microsoft"
                                    value={companies.value}
                                    onAdd={(chip): void => {
                                      setFieldValue(`userCriteria.${i}.companies`, [
                                        ...companies.value,
                                        chip,
                                      ])
                                    }}
                                    onDelete={(chip, index): void => {
                                      const tmpArr = [...companies.value]
                                      tmpArr.splice(index, 1)
                                      setFieldValue(`userCriteria.${i}.companies`, tmpArr)
                                    }}
                                    fullWidth
                                  />
                                  {companies.errors && companies.touched ? (
                                    <Alert variant="danger">{companies.errors}</Alert>
                                  ) : null}
                                </Form.Group>
                                <Form.Group
                                  controlId="dnc"
                                  className="criteria-input"
                                  style={
                                    companySearch.value
                                      ? { display: 'block', marginRight: 20 }
                                      : { display: 'none' }
                                  }
                                >
                                  <ListItemText
                                    primary="DO NOT ENGAGE COMPANIES"
                                    className="sub-title engage align"
                                    onClick={(): void => handleEnagePage()}
                                  />
                                  <ChipInput
                                    label=""
                                    helperText="Example: maverick.io, yourcompanyurl.com, competitorname.net"
                                    value={dncCompanies.value}
                                    onAdd={(chip): void => {
                                      setFieldValue(`userCriteria.${i}.dncCompanies`, [
                                        ...dncCompanies.value,
                                        chip,
                                      ])
                                    }}
                                    onDelete={(chip, index): void => {
                                      const tmpArr = [...dncCompanies.value]
                                      tmpArr.splice(index, 1)
                                      setFieldValue(`userCriteria.${i}.dncCompanies`, tmpArr)
                                    }}
                                    fullWidth
                                  />
                                  <p className="notes">
                                    Note: Company domains added here are specific to your Recon.
                                    Click
                                    <a href="/do-not-engage">here </a>
                                    to add account wide Do Not Engage Companies.
                                  </p>
                                </Form.Group>
                              </div>
                              <div className="section">
                                <Form.Group
                                  controlId={`userCriteria.${i}.industries`}
                                  className="criteria-input"
                                  style={
                                    !companySearch.value
                                      ? { display: 'block' }
                                      : { display: 'none', maxWidth: '800px' }
                                  }
                                >
                                  <ListItemText
                                    primary="INDUSTRIES"
                                    className="sub-title align title-padding"
                                  />
                                  {/* eslint-disable prettier/prettier, @typescript-eslint/indent */}
                                  <MultiSelect
                                    className="industry-multiselect-wrap"
                                    overrideStrings={{ selectSomeItems: 'Industries...' }}
                                    disabled={companySearch.value}
                                    options={industryOptions}
                                    value={
                                      industries.value &&
                                      !companySearch.value &&
                                      industries.value[0] !== 'all'
                                        ? industries.value.map(industry => ({
                                            label: industry,
                                            value: industry,
                                          }))
                                        : industryOptions
                                    }
                                    onChange={(value): void => {
                                      setFieldValue(
                                        `userCriteria.${i}.industries`,
                                        value.map(function makeArr(obj) {
                                          return obj.value
                                        }),
                                      )
                                    }}
                                    labelledBy={`userCriteria.${i}.industries`}
                                  />
                                  {/* eslint-enable prettier/prettier, @typescript-eslint/indent */}
                                  {industries.errors && industries.touched ? (
                                    <Alert variant="danger">{industries.errors}</Alert>
                                  ) : null}
                                </Form.Group>
                                <Form.Group
                                  controlId={`userCriteria-${i}-titles`}
                                  className="criteria-input"
                                >
                                  <ListItemText
                                    primary={
                                      <div
                                        style={{
                                          width: '100%',
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <span>TITLE KEYWORDS</span>
                                        {titles.value?.length > 0 ? (
                                          <RenderClearTagsButton
                                            handleClearTags={(): void => {
                                              setFieldValue(`userCriteria.${i}.titles`, [])
                                            }}
                                          />
                                        ) : null}
                                      </div>
                                    }
                                    className="sub-title align"
                                  />
                                  <ChipInput
                                    label=""
                                    helperText="Example: Sales, Growth, Technology, Security, etc."
                                    value={titles.value}
                                    onAdd={(chip): void => {
                                      setFieldValue(`userCriteria.${i}.titles`, [
                                        ...titles.value,
                                        chip,
                                      ])
                                    }}
                                    onDelete={(chip, index): void => {
                                      const tmpArr = [...titles.value]
                                      tmpArr.splice(index, 1)
                                      setFieldValue(`userCriteria.${i}.titles`, tmpArr)
                                    }}
                                    fullWidth
                                  />
                                </Form.Group>
                                <Form.Group
                                  controlId={`userCriteria-${i}-titleExclusions`}
                                  className="criteria-input"
                                >
                                  <ListItemText
                                    primary={
                                      <div
                                        style={{
                                          width: '100%',
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <span>EXCLUDE TITLE KEYWORDS</span>
                                        {titleExclusions.value?.length > 0 ? (
                                          <RenderClearTagsButton
                                            handleClearTags={(): void => {
                                              setFieldValue(`userCriteria.${i}.titleExclusions`, [])
                                            }}
                                          />
                                        ) : null}
                                      </div>
                                    }
                                    className="sub-title align"
                                  />
                                  <ChipInput
                                    label=""
                                    helperText="Example: Director, Manager, etc."
                                    value={titleExclusions.value}
                                    onAdd={(chip): void => {
                                      setFieldValue(`userCriteria.${i}.titleExclusions`, [
                                        ...titleExclusions.value,
                                        chip,
                                      ])
                                    }}
                                    onDelete={(chip, index): void => {
                                      const tmpArr = [...titleExclusions.value]
                                      tmpArr.splice(index, 1)
                                      setFieldValue(`userCriteria.${i}.titleExclusions`, tmpArr)
                                    }}
                                    fullWidth
                                  />
                                </Form.Group>
                                <Form.Group
                                  controlId="campaign"
                                  className="criteria-input"
                                  style={
                                    activated.value && enabled.value && companySearch.value
                                      ? { display: 'block' }
                                      : { display: 'none' }
                                  }
                                >
                                  <ListItemText
                                    primary="ASSIGN TO MISSION"
                                    className="sub-title title-padding"
                                  />
                                  <Form.Control
                                    as="select"
                                    disabled={!activated.value}
                                    value={missionName.value}
                                    onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                                      setFieldValue(
                                        `userCriteria.${i}.missionName`,
                                        e.currentTarget.value,
                                      )
                                    }}
                                  >
                                    {userCriteria
                                      ? userCriteria[i]?.missions.firstTouch.map(
                                          currentMissionName => (
                                            <option
                                              key={currentMissionName}
                                              value={currentMissionName}
                                            >
                                              {[
                                                currentMissionName.slice(
                                                  0,
                                                  currentMissionName.length - 1,
                                                ),
                                                '#',
                                                currentMissionName.slice(-1),
                                              ].join('')}
                                            </option>
                                          ),
                                        )
                                      : ''}
                                  </Form.Control>
                                </Form.Group>
                              </div>
                              <div className="section">
                                <Form.Group
                                  controlId="dnc"
                                  className="criteria-input do-not-engage"
                                  style={
                                    !companySearch.value
                                      ? { display: 'block', marginRight: 20 }
                                      : { display: 'none' }
                                  }
                                >
                                  <ListItemText
                                    primary="DO NOT ENGAGE COMPANIES"
                                    className="sub-title engage align"
                                    onClick={(): void => handleEnagePage()}
                                  />
                                  <ChipInput
                                    label=""
                                    helperText="Example: maverick.io, yourcompanyurl.com, competitorname.net"
                                    value={dncCompanies.value}
                                    onAdd={(chip): void => {
                                      setFieldValue(`userCriteria.${i}.dncCompanies`, [
                                        ...dncCompanies.value,
                                        chip,
                                      ])
                                    }}
                                    onDelete={(chip, index): void => {
                                      const tmpArr = [...dncCompanies.value]
                                      tmpArr.splice(index, 1)
                                      setFieldValue(`userCriteria.${i}.dncCompanies`, tmpArr)
                                    }}
                                    fullWidth
                                  />
                                  <p className="notes">
                                    Note: Company domains added here are specific to your Recon.
                                    Click
                                    <a href="/do-not-engage">here </a>
                                    to add account wide Do Not Engage Companies.
                                  </p>
                                </Form.Group>
                                <Form.Group
                                  controlId="campaign"
                                  className="criteria-input"
                                  style={
                                    activated.value && enabled.value && !companySearch.value
                                      ? { display: 'block', width: '30%' }
                                      : { display: 'none' }
                                  }
                                >
                                  <ListItemText
                                    primary="ASSIGN TO MISSION"
                                    className="sub-title title-padding"
                                  />
                                  <Form.Control
                                    as="select"
                                    disabled={!activated.value}
                                    value={missionName.value}
                                    onChange={(e: ChangeEvent<HTMLSelectElement>): void => {
                                      setFieldValue(
                                        `userCriteria.${i}.missionName`,
                                        e.currentTarget.value,
                                      )
                                    }}
                                  >
                                    {userCriteria
                                      ? userCriteria[i]?.missions.firstTouch.map(
                                          currentMissionName => (
                                            <option
                                              key={currentMissionName}
                                              value={currentMissionName}
                                            >
                                              {[
                                                currentMissionName.slice(
                                                  0,
                                                  currentMissionName.length - 1,
                                                ),
                                                '#',
                                                currentMissionName.slice(-1),
                                              ].join('')}
                                            </option>
                                          ),
                                        )
                                      : ''}
                                  </Form.Control>
                                </Form.Group>
                              </div>
                              <Form.Group
                                controlId={`actions-${i}`}
                                className="save-template-group"
                              >
                                <LoadingButton
                                  variant="primary"
                                  type="button"
                                  onClick={(): void => {
                                    handleClear(setFieldValue, `userCriteria.${i}`)
                                  }}
                                >
                                  Clear Criteria
                                </LoadingButton>
                                <LoadingButton
                                  variant="primary"
                                  isLoading={isLoading}
                                  type="submit"
                                >
                                  Update Recon
                                </LoadingButton>
                              </Form.Group>
                            </div>
                          )
                        })}
                      </div>
                    )
                  }}
                </FieldArray>
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
export default inject('settings')(observer(AdminCriteria))
